import { FormGroup } from '@angular/forms';
import { CommonField } from '../models/Field/FieldBase';

// Does a final transform on form's values before sending a request.
export function convertFormToDTO(
  form: FormGroup,
  fields: CommonField[]
): { [key: string]: string | number } {
  let formDTO = {};

  fields.forEach((f) => {
    const result = {};
    const formControl = form.controls[f.key];
    result[f.key] = f.dtoTransform(formControl.value);
    if (f.componentType === 'file-picker' && f.file.newContent) {
      const KEY = f.key.slice(0, f.key.toLowerCase().indexOf('name'));
      const CONTENT_KEY = KEY + 'Content';
      result[f.key] = f.file.newName || f.file.currName;
      if (f.file.newContent) {
        result[CONTENT_KEY] = f.file.newContent;
      }
    }
    formDTO = { ...formDTO, ...result };
  });

  return formDTO;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/utilities/convertFormToDTO.ts